"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _NotificationCenterItem = require("./NotificationCenterItem");

var NotificationCenterPhrasesPreLoad = function NotificationCenterPhrasesPreLoad() {
  return (0, _preact.h)("div", {
    className: "notification-center__phrases"
  }, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.notifications"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.new"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.recent"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.theEnd"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.theEnd"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.markAsRead"
  }), (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.markAsUnread"
  }), (0, _preact.h)(_phrase.default, {
    p: _NotificationCenterItem.messagePhraseByType[_NotificationCenterItem.NotificationReason.newReply]
  }), (0, _preact.h)(_phrase.default, {
    p: _NotificationCenterItem.messagePhraseByType[_NotificationCenterItem.NotificationReason.mentionInReply]
  }));
};

var _default = NotificationCenterPhrasesPreLoad;
exports.default = _default;